import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

import DefaultImage from "assets/Images/BrandImage1.png";

import MagnetAttribute from "components/atoms/cards/magnet/CardStats";
import { BrandContext } from "components/context/BrandContext";
import { Arrow } from "components/atoms/Icon";

import { getMagnetPageLink, isMagnetInPublishedState } from "utils/helpers";
import { formatToCommaSeparatedString } from "utils/HelperFunctions";
import { ROUTES } from "../../../constants";

function MagnetBrandDashboardCard(magnet: Magnet) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { id, name, magnetized_because, max_supply, open_activations, percentage_listed, image_url, status } = magnet;
  const navigate = useNavigate();
  const { brandId } = useContext(BrandContext);

  const handleMagnetCardClick = () => {
    navigate(`${ROUTES.BRAND_DASHBOARD}?m=${id}`);
  };

  const isMagnetPublished = isMagnetInPublishedState(status);

  const handleMagnetViewDetails = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    if (isMagnetPublished) {
      navigate(getMagnetPageLink(brandId as string, id));
    } else {
      navigate(`${ROUTES.BRAND_DASHBOARD}?m=${id}`);
    }
  };

  return (
    <div
      className="w-full cursor-pointer rounded-xl border-1.5 border-white border-opacity-10
        p-3 font-satoshi shadow-modal transition-transform duration-100 hover:scale-105 hover:border-opacity-20 hover:bg-white hover:bg-opacity-[0.04]"
      onClick={handleMagnetCardClick}
    >
      <div className="flex flex-col space-x-4 xl:flex-row ">
        <div className="aspect-1 h-full w-52">
          <img
            src={image_url || DefaultImage}
            alt={name}
            className=" h-full w-full min-w-[208px] rounded-xl border border-white border-opacity-5  object-cover object-center"
          />
        </div>
        <div className="flex flex-col items-start justify-between">
          <div>
            <p
              title={name}
              className="line-clamp-1 break-all text-sm font-bold leading-6 text-white first-letter:uppercase"
            >
              {name}
            </p>
            <p
              title={magnetized_because}
              className="mt-2 line-clamp-2 break-all font-satoshi text-base font-450 leading-tight
             text-white text-opacity-40 xl:text-xxs 2xl:text-xs"
            >
              {magnetized_because}
            </p>
          </div>

          <div className="flex flex-col items-start justify-between">
            <div className="item relative flex w-full  flex-row justify-between text-base xl:text-xxs">
              <MagnetAttribute
                additionalClasses="flex-shrink"
                pText="TOTAL <br/>SUPPLY"
                sText={formatToCommaSeparatedString(max_supply, "decimal")}
              />
              <MagnetAttribute pText="OPEN ACTIVATIONS" sText={open_activations?.toString()} />
              <MagnetAttribute pText="% LISTED FOR SALE" sText={`${percentage_listed}%`} additionalClasses="ml-3.5" />
            </div>

            <button
              type="button"
              className="mt-3 flex items-center text-xxs font-bold text-white"
              onClick={handleMagnetViewDetails}
            >
              {isMagnetPublished ? "VIEW MAGNET PAGE" : "PUBLISH TO VIEW"}
              <div className="ml-2">
                <Arrow />
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MagnetBrandDashboardCard;
